module.exports = __webpack_public_path__ + "img/India.fce4e4d7.png";